/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "lambda",
            "endpoint": "https://rftl2ajl0h.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://o7qmwp2zefcqzpdtb3kg6wqrte.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-z7f4i3uajzau3h7x6abtfwk234",
    "aws_cognito_identity_pool_id": "eu-central-1:177f6906-3437-4318-9d9f-018be8d4b2dc",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_I40fzKmKh",
    "aws_user_pools_web_client_id": "4re0274am8uo944umslg3fnv6f",
    "oauth": {
        "domain": "skylink-byphone-develop.auth.eu-central-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL",
        "PHONE_NUMBER"
    ]
};


export default awsmobile;
